import classNames from 'classnames'
import React, { ReactNode } from 'react'
import { SkeletonCheckableField } from './skeleton-checkable-field'

export interface CheckableFieldTypeProps extends React.ComponentPropsWithoutRef<'input'> {
  type: 'radio' | 'checkbox'
}

export interface CheckableFieldProps extends CheckableFieldTypeProps {
  id: string
  name: string
  label: string | ReactNode
  describedBy?: string | undefined
  isRequired?: boolean
  isDisabled?: boolean
  value?: string
  isSkeleton?: boolean
  hasNoVerticalSpacing?: boolean
}

export const CheckableField = React.forwardRef<HTMLInputElement, CheckableFieldProps>(
  (
    {
      id,
      name,
      label,
      type,
      describedBy = `${id}--help-text ${id}--validation-msg`,
      isRequired,
      isDisabled,
      value,
      isSkeleton,
      hasNoVerticalSpacing = false,
      disabled,
      ...props
    }: CheckableFieldProps,
    ref,
  ) => {
    const className = classNames('c-checkable-field', {
      'c-checkable-field--no-vertical-spacing': hasNoVerticalSpacing,
    })
    return (
      <div className={className}>
        {isSkeleton && <SkeletonCheckableField type={type} />}
        {!isSkeleton && (
          <>
            <input
              ref={ref}
              className='c-checkable-field__input'
              id={id}
              type={type}
              name={name}
              disabled={isDisabled ?? disabled}
              {...props}
            />
            <label className='c-checkable-field__label' htmlFor={id}>
              {label}
            </label>
          </>
        )}
      </div>
    )
  },
)
